"use client";

import React, { useEffect, useState } from "react";
import CommonSchema from "@/components/common/CommonSchema";
import { Banner } from "../common/Banner";
import { FadeInSection } from "../common/FadeInSection";
import { Shield } from "lucide-react";
import { useAppSelector } from "@/store/hooks";
import { cleanHeaderTags, createLookupObject } from "@/_helper/helper";

export default function PrivacyPolicyClient({ cmsData, initialBanner }: { cmsData: any; initialBanner?: any }) {
  const BannerList = useAppSelector((state) => state.home.BannerList);
  const banner: any =
    initialBanner ||
    BannerList?.find(
      (banner: any) => banner?.BannerType === "privacy-policy",
    ) || {};

  const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, any>>({});

  useEffect(() => {
    if (cmsData && cmsData.length > 0) {
      setLookUpCMSData(createLookupObject(cmsData, "Name"));
    }
  }, [cmsData]);

  return (
    <div className="min-h-screen bg-[#fdfcfa]">
      <CommonSchema />
      <Banner
        title={banner?.BannerTitle || "Privacy Policy"}
        description={banner?.Description}
        bgImage={banner?.BannerImage}
        // icon={<Shield className="w-12 h-12 text-[#d4af37]" />}
      />

      <section className="py-10 md:py-15 blog-content">
        <div className="max-w-7xl mx-auto px-6">
          <FadeInSection>
            {lookUpCMSData?.["Privacy Policy - Content"] ? (
              <div
                className="space-y-10"
                dangerouslySetInnerHTML={{
                  __html: cleanHeaderTags(
                    lookUpCMSData?.["Privacy Policy - Content"]?.Template,
                  ),
                }}
              />
            ) : (
              <div className="no-file-found flex flex-col items-center justify-center py-8 px-4 text-center bg-gray-100 dark:bg-gray-800 rounded-lg shadow-md">
                <svg
                  className="w-12 h-12 dark:text-gray-400 text-gray-700"
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 24 24"
                  height="200px"
                  width="200px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="File_Off">
                    <g>
                      <path d="M4,3.308a.5.5,0,0,0-.7.71l.76.76v14.67a2.5,2.5,0,0,0,2.5,2.5H17.44a2.476,2.476,0,0,0,2.28-1.51l.28.28c.45.45,1.16-.26.7-.71Zm14.92,16.33a1.492,1.492,0,0,1-1.48,1.31H6.56a1.5,1.5,0,0,1-1.5-1.5V5.778Z"></path>
                      <path d="M13.38,3.088v2.92a2.5,2.5,0,0,0,2.5,2.5h3.07l-.01,6.7a.5.5,0,0,0,1,0V8.538a2.057,2.057,0,0,0-.75-1.47c-1.3-1.26-2.59-2.53-3.89-3.8a3.924,3.924,0,0,0-1.41-1.13,6.523,6.523,0,0,0-1.71-.06H6.81a.5.5,0,0,0,0,1Zm4.83,4.42H15.88a1.5,1.5,0,0,1-1.5-1.5V3.768Z"></path>
                    </g>
                  </g>
                </svg>
                <h3 className="text-xl font-medium mt-4 text-gray-700 dark:text-gray-200">
                  No data found
                </h3>
                <p className="text-gray-500 dark:text-gray-400 mt-2">
                  The data you are looking for is not available.
                </p>
              </div>
            )}
            {/* <div className="space-y-10">
              <h2>Privacy Policy</h2>
              <div>
                <p>
                  This privacy policy sets out how we use and protects any
                  information that you give us when you use this website.
                </p>
                <p>
                  We are committed to ensuring that your privacy is protected.
                  Should we ask you to provide certain information by which you
                  can be identified when using this website, then you can be
                  assured that it will only be used in accordance with this
                  privacy statement.
                </p>
                <p>
                  We may change this policy from time to time by updating this
                  page. You should check this page from time to time to ensure
                  that you are happy with any changes.
                </p>
              </div>
              <div>
                <h3>What we collect</h3>
                <b className="font-medium">
                  We may collect the following information:
                </b>
                <ul className="collect-list">
                  <li>name and job title</li>
                  <li>contact information including email address</li>
                  <li>
                    demographic information such as postcode, preferences and
                    interests
                  </li>
                </ul>
              </div>
              <div>
                <h3>What we do with the information we gather</h3>
                <b className="font-medium">
                  We require this information to understand your needs and
                  provide you with a better service, and for the following
                  reasons:
                </b>
                <ul className="collect-list">
                  <li>Internal record keeping.</li>
                  <li>
                    We may use the information to improve our products and
                    services.
                  </li>
                  <li>
                    We may periodically send promotional email about new
                    products, special offers or other information which we think
                    you may find interesting using the email address which you
                    have provided, to do this you need to opt in for this
                    service.
                  </li>
                  <li>We may contact you by email, phone, or mail.</li>
                  <li>
                    We may use the information to customise the website
                    according to your interests.
                  </li>
                </ul>
              </div>
              <div>
                <h3>Security</h3>
                <p>
                  We are committed to ensuring that your information is secure.
                  To prevent unauthorised access or disclosure we have put in
                  place suitable physical, electronic and managerial procedures
                  to safeguard and secure the information we collect online.
                </p>
              </div>
              <div>
                <h3>How we use cookies</h3>
                <p>
                  A cookie is an element of data that a website can send to your
                  browser, which may then store it on your system. We use
                  cookies in some of our pages to store your preferences and
                  record session information. The information that we collect is
                  then used to ensure a more personalized service level for our
                  users. Please be assured though that your credit card number
                  will not be saved for security reasons. You must type the
                  credit card number each time you make a purchase.
                </p>
                <p>
                  You can adjust settings on your browser so that you will be
                  notified when you receive a cookie. Please refer to your
                  browser documentation to check if cookies have been enabled on
                  your computer or to request not to receive cookies. As cookies
                  allow you to take advantage of some of the Website’s essential
                  features, we recommend that you accept cookies. For instance,
                  if you block or otherwise reject our cookies, you will not be
                  able to book flights or use any products or services on the
                  Website that require you to log-in.
                </p>
                <p>
                  This information is treated confidentially and will not be
                  shared with anyone outside of the Company unless otherwise
                  stated in this Privacy Policy. We will only use this
                  information to make informed decisions regarding the purchase
                  of online advertising.
                </p>
              </div>
              <div>
                <h3>Links to other websites</h3>
                <p>
                  Our website may contain links to enable you to visit other
                  websites of interest easily. However, once you have used these
                  links to leave our site, you should note that we do not have
                  any control over that other website. Therefore, we cannot be
                  responsible for the protection and privacy of any information
                  which you provide whilst visiting such sites and such sites
                  are not governed by this privacy statement. You should
                  exercise caution and look at the privacy statement applicable
                  to the website in question.
                </p>
              </div>
              <div>
                <h3>Controlling your personal information</h3>
                <p>
                  You may choose to restrict the collection or use of your
                  personal information in the following ways:
                </p>
                <p>
                  We will not sell, distribute or lease your personal
                  information to third parties unless we have your permission or
                  are required by law to do so.
                </p>
                <p>
                  You may request details of personal information which we hold
                  about you under the Data Protection Act 1998
                </p>
                <p>
                  If you believe that any information we are holding on you is
                  incorrect or incomplete, please write to or email us as soon
                  as possible, at the above address. We will promptly correct
                  any information found to be incorrect.
                </p>
              </div>
            </div> */}
          </FadeInSection>
        </div>
      </section>
    </div>
  );
}
